<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { useStore } from "@/state/pinia_store.js";

import { getEquityList, getPositionList, getSpotPositionList, getEquityAll, 
getMargin, getTotalMargin, getStrategyRet, getStrategyFunding} from '@/api/user'
/**
 * Starter component
 */
export default {
  page: {
    title: "账户概览",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader},
  props: {
    updating: {
      type: Boolean,
    },
  },
  data() {
    return {
      // stores: useStore(),
      contractPosition: [],
      contractSymbol: [],
      title: "账户概览",
      items: [
        {
          text: "Utility",
          href: "/"
        },
        {
          text: "Starter Page",
          active: true
        }
      ],
      equitydata: [],
      equitydate: [],
      equityoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      margindata: [],
      margindate: [],
      marginoption: {
        backgroundColor: '#2A3042',
        title: {
          text: '',
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          bottom: 90
        },
        dataZoom: [
          {
            type: 'inside'
          },
          {
            type: 'slider'
          }
        ],
        xAxis: {
          data: [],
          silent: false,
          splitLine: {
            show: false
          },
          splitArea: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          scale:true,
          splitArea: {
            show: false
          }
        },
        series: [
          {
            type: 'line',
            data: [],
            // Set `large` for large data amount
            large: true
          }
        ]
      },
      contractOption: {
        title:
        {
          text: '',
          left: 'center',
          textStyle: {
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '币本位合约',
            type: 'pie',
            radius: '60%',
            data: [],
            label:{
              show: true,
              position: 'outside'
              // formatter:'{b}：{c} {d}%'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      spotOption: {
        title: {
          text: '',
          left: 'center',
          textStyle: {
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '现货',
            type: 'pie',
            radius: '60%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      account: '',
      alias: '',
      baseEquity: 0,
      latestEquity: 0,
      weekRet: 0,
      MonthRet: 0,
      YearRet: 0,
      weekAmount: 0,
      MonthAmount: 0,
      YearAmount: 0,
      fundingList: [],
      weighted_hist_funding: 0,
      weighted_realtime_funding: 0,
      isAdmin: 0
    };
  },
  methods: {
    onResize(e) {
      this.contractChart_ = this.$echarts.init(document.getElementById('contractChart'))
      this.contractChart_.resize()

      this.spotChart_ = this.$echarts.init(document.getElementById('spotChart'))
      this.spotChart_.resize()

      this.equityChart_ = this.$echarts.init(document.getElementById('equityChart'),'dark')
      this.equityChart_.resize()
    },
    getCurrentTime() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss;
      // console.log(this.gettime)  
    },
    showContractChart() {
      getPositionList(this.alias).then((res) => {
        console.log(res)
        let contractChart_ = this.$echarts.init(document.getElementById('contractChart'))
        // console.log(contractChart_)

        let posiiondata = []

        let positionsum = 0

        for (let i = 0; i < res.length; ++i) {
          if (parseFloat(res[i]['position']) != 0.0) {
            this.contractSymbol.push(res[i]['symbol'].substring(0, res[i]['symbol'].length - 8))
            posiiondata.push({
              value: parseFloat(res[i]['position']),
              name: res[i]['symbol']
            })
            positionsum = positionsum + parseFloat(res[i]['position'])
          }
        }

        positionsum = positionsum * 10.0

        console.log('posiion data')
        console.log(posiiondata)

        this.contractOption.title.text = "合约价值" + positionsum.toFixed(2).toString()+"USD",
        this.contractOption.series[0].data = posiiondata

        contractChart_.setOption(this.contractOption)

      }).catch((error) => {
        console.log("get position List error: ", error);
      })
    },
    showSpotChart() {
      getMargin(this.alias).then((res) => {
      let spotChart_ = this.$echarts.init(document.getElementById('spotChart'))

      let posiiondata = []

      let total_margin = 0
      let margin = 0

      for (let i = 0; i < res.length; ++i) {
          margin = -parseFloat(res[i]['notionalValue']) * parseFloat(res[i]['markPrice'])
          posiiondata.push({
            value: margin.toFixed(4),
            name: res[i]['symbol']
          })

          total_margin = total_margin + margin
      }

      this.spotOption.title.text = "保证金价值" + total_margin.toFixed(2).toString()+"USD"
      this.spotOption.series[0].data = posiiondata
      spotChart_.setOption(this.spotOption)
      // spotChart_.setOption(option)
      // window.addEventListener("resize", () => {
      //   this.spotChart_.resize();
      // })
      }).catch((error) => {
          console.log("get position List error: ", error);
      })
    },
    showMarginChart() {
      getTotalMargin(this.alias).then((res) => {
      this.marginChart_ = this.$echarts.init(document.getElementById('marginChart'),'dark')

      this.margindata = []
      this.margindate = []

      for (let i = 0; i < res.length; ++i) {
        this.margindata.push(parseFloat(res[i]['uMargin']) / parseFloat(res[i]['totalEquity']))
        this.margindate.push(res[i]['timestamp'])
      }

      // console.log('equitydata')
      // console.log(this.equitydata)

      this.marginoption.xAxis.data = this.margindate
      this.marginoption.series[0].data = this.margindata
      this.marginoption.title.text = "仓位比例"

      this.marginChart_.setOption(this.marginoption)
      }).catch((error) => {
        console.log(error)
      })
    },
    showEquityChart() {
      getEquityAll(this.alias).then((res) => {
      this.equityChart_ = this.$echarts.init(document.getElementById('equityChart'),'dark')

      this.equitydata = []
      this.equitydate = []

      for (let i = 0; i < res.length; ++i) {
        this.equitydata.push(parseFloat(res[i]['totalEquity']))
        this.equitydate.push(res[i]['timestamp'])
      }

      // console.log('equitydata')
      // console.log(this.equitydata)

      this.equityoption.xAxis.data = this.equitydate
      this.equityoption.series[0].data = this.equitydata
      this.equityoption.title.text = "PnL"

      this.equityChart_.setOption(this.equityoption)
      }).catch((error) => {
        console.log(error)
      })
    },
    getEquityRet() {
      getStrategyRet(this.alias).then((res) => {
        console.log('get rett')
        console.log(res)
        this.weekAmount = res[0]['amount']
        this.weekRet = res[0]['apr']

        this.MonthAmount = res[1]['amount']
        this.MonthRet = res[1]['apr']

        this.YearAmount = res[2]['amount']
        this.YearRet = res[2]['apr']

        this.baseEquity = res[3]
        this.latestEquity = res[4]

      }).catch((error) => {
        console.log(error)
      })
    },
    getFundingList() {
      this.weighted_hist_funding = 0.0
      this.weighted_realtime_funding = 0.0

      getStrategyFunding(this.alias).then((res) => {
        this.fundingList = res[0]

        for (let i = 0; i < this.fundingList.length; ++i) {
          this.weighted_hist_funding = this.weighted_hist_funding + parseFloat(this.fundingList[i]['funding8hour']) * parseFloat(this.fundingList[i]['positionratio'])
          this.weighted_realtime_funding = this.weighted_realtime_funding + this.fundingList[i]['rtfundingrate'] * this.fundingList[i]['positionratio']
        }

        this.weighted_hist_funding = this.weighted_hist_funding * 10000
        this.weighted_hist_funding = this.weighted_hist_funding.toFixed(2)

        this.weighted_realtime_funding = this.weighted_realtime_funding * 10000
        this.weighted_realtime_funding = this.weighted_realtime_funding.toFixed(2)

        for (let i = 0; i < this.fundingList.length; ++i) {
          this.fundingList[i]['funding8hour'] = this.fundingList[i]['funding8hour'] * 10000
          this.fundingList[i]['funding8hour'] = this.fundingList[i]['funding8hour'].toFixed(2)

          this.fundingList[i]['rtfundingrate'] = this.fundingList[i]['rtfundingrate'] * 10000
          this.fundingList[i]['rtfundingrate'] = this.fundingList[i]['rtfundingrate'].toFixed(2)

          this.fundingList[i]['oneday'] = this.fundingList[i]['oneday'] * 10000
          this.fundingList[i]['oneday'] = this.fundingList[i]['oneday'].toFixed(2)

          this.fundingList[i]['threeday'] = this.fundingList[i]['threeday'] * 10000
          this.fundingList[i]['threeday'] = this.fundingList[i]['threeday'].toFixed(2)

          this.fundingList[i]['sevenday'] = this.fundingList[i]['sevenday'] * 10000
          this.fundingList[i]['sevenday'] = this.fundingList[i]['sevenday'].toFixed(2)
        }

        // this.$forceUpdate()
      }).catch((error) => {
        console.log(error)
      })
    },
    checkAccount() {
      if (this.$route.query.alias)
      {
        if (this.$route.query.alias != this.alias)
        {
          // this.account = localStorage.accountName
          // // console.log("切换账户：" + this.account)

          // if (this.account == '资金费率A') {
          //   this.alias = 'funding'
          // }

          // if (this.account == '套利0323') {
          //   this.alias = 'funding2'
          // }

          // if (this.account == 'Abby') {
          //   this.alias = 'Abby'
          // }
          this.alias = this.$route.query.alias

          this.getEquityRet()
          this.getFundingList()
          this.showEquityChart()
          this.showContractChart()
          this.showSpotChart()
          // this.showMarginChart()
        }
      }
    }
  },
  mounted() {
    // console.log("hh")
    this.isAdmin = localStorage.getItem("is_admin")
    if (localStorage.accountName) {
      this.account = localStorage.accountName
      // console.log(this.account)

      if (this.account == '资金费率A') {
        this.alias = 'funding'
      }

      if (this.account == '套利0323') {
        this.alias = 'funding2'
      }

      if (this.account == 'Abby') {
        this.alias = 'Abby'
      }


      // 
    }
    this.alias = this.$route.query.alias
    console.log(this.alias)
    if (!this.alias) {
      console.log("to default hhh")
      this.alias = localStorage.getItem("default_alias")
      let default_url = localStorage.getItem('default_url');
      this.$router.push(default_url)
    }

    this.my_timer = setInterval(this.checkAccount, 100)
    this.getEquityRet()
    this.getFundingList()
    this.showEquityChart()
    this.showContractChart()
    this.showSpotChart()
    // this.showMarginChart()
  },
  destroyed(){
            //console.log("销毁-----------------------之后");
        },
  beforeDestroy(){
    clearInterval(this.my_timer)
    //console.log("我要死了啦啦啦啦啦啦绿绿绿绿绿绿绿绿绿绿绿")
  }
};
</script>
<template>
  <Layout>
    <PageHeader
      :title="title"
    />
    <!-- <div class="row">
      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="mr-3 align-self-center">
                <i class="mdi mdi-bitcoin h2 text-warning mb-0" />
              </div>
              <div class="media-body">
                <p class="text-muted mb-2">
                  本周收益
                </p>
                <h5 class="mb-0">
                  1%
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="mr-3 align-self-center">
                <i class="mdi mdi-ethereum h2 text-primary mb-0" />
              </div>
              <div class="media-body">
                <p class="text-muted mb-2">
                  本月收益
                </p>
                <h5 class="mb-0">
                  1%
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="media">
              <div class="mr-3 align-self-center">
                <i class="mdi mdi-litecoin h2 text-info mb-0" />
              </div>
              <div class="media-body">
                <p class="text-muted mb-2">
                  年化收益
                </p>
                <h5 class="mb-0">
                  15%
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <div class="row">

      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                初始金额
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                {{baseEquity}}
              </h4>
            </div>
          </div>
        </div>
      </div>

    <div class="col-sm-6">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-archive-in" />
              </span>
            </div>
            <h5 class="font-size-14 mb-0">
              最新净值
            </h5>
          </div>
          <div class="text-muted mt-4">
            <h4>
                  {{latestEquity}}
            </h4>
          </div>
        </div>
      </div>
    </div>



      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-copy-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                本周收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4 >
                $ {{weekAmount}}
                <i v-if="weekAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <div class="d-flex">
                <span v-if="weekAmount >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{weekRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{weekRet}}</span>
                <span class="ml-2 text-truncate">7日年化收益</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-archive-in" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                本月收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                $ {{MonthAmount}}
                <i v-if="MonthAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>
              <div class="d-flex">
                <span v-if="MonthRet >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{MonthRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{MonthRet}}</span>
                <span class="ml-2 text-truncate">30日年化收益</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center mb-3">
              <div class="avatar-xs mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
                >
                  <i class="bx bx-purchase-tag-alt" />
                </span>
              </div>
              <h5 class="font-size-14 mb-0">
                本年收益
              </h5>
            </div>
            <div class="text-muted mt-4">
              <h4>
                $ {{YearAmount}}
                <i v-if="YearAmount >= 0" class="mdi mdi-chevron-up ml-1 text-success" />
                <i v-else class="mdi mdi-chevron-down ml-1 text-danger" />
              </h4>

              <div class="d-flex">
                <span v-if="YearRet >= 0" class="badge badge-soft-success font-size-12" v-format="'0.##%'">{{YearRet}}</span>
                <span v-else class="badge badge-soft-danger font-size-12" v-format="'0.##%'">{{YearRet}}</span>
                <span class="ml-2 text-truncate">年化收益</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="isAdmin > 10" class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              合约持仓
            </h4>
            <div id="contractChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              现货保证金
            </h4>
            <div id="spotChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div  v-if="isAdmin > 10" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table data -->
            <!-- <T :transactions="strategy_list" /> -->
            <Loader :loading="updating">
              <div class="table-responsive mb-0">
                <table class="table table-centered table-nowrap">
                  <thead class="thead-light">
                    <tr>
                      <th>品种</th>
                      <th>持仓比例</th>
                      <th>历史资金费率</th>
                      <th>实时资金费率</th>
                      <th>1day</th>
                      <th>3day</th>
                      <th>7day</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="data in fundingList"
                      :key="data.symbol"
                    >
                      <td>
                        <a
                          href="javascript: void(0);"
                          class="text-body font-weight-bold"
                        >{{ data.symbol }}</a>
                      </td>
                      <td v-format="'0.##%'">{{ data.positionratio }}</td>
                      <td>{{ data.funding8hour }} bp</td>
                      <td>{{ data.rtfundingrate }} bp</td>
                      <td>{{ data.oneday }} bp</td>
                      <td>{{ data.threeday }} bp</td>
                      <td>{{ data.sevenday }} bp</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- end table -->
            </Loader>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <div v-if="isAdmin > 10" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table data -->
            <!-- <T :transactions="strategy_list" /> -->
            <Loader :loading="updating">
              <div class="table-responsive mb-0">
                <table class="table table-centered table-nowrap">
                  <thead class="thead-light">
                    <tr>
                      <th>加权历史资金费率</th>
                      <th>加权实时资金费率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ weighted_hist_funding }} bp</td>
                      <td>{{ weighted_realtime_funding }} bp</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- end table -->
            </Loader>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

    <!-- <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            仓位比例
            </h4>
            <div id="marginChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row" v-resize @resize="onResize">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
            累计收益
            </h4>
            <div id="equityChart" style="height:400px;"></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>